declare global {
  interface Window {
    gwsInstallationId?: () => Promise<string | undefined>
  }
}

let scriptLoad: Promise<void> | undefined

const loadScript = () => scriptLoad ??= new Promise((resolve) => {
  const script = document.createElement("script")
  const timeout = setTimeout(resolve, 150)
  script.src = "/installation-id.js"
  script.onload = script.onerror = () => {
    clearTimeout(timeout)
    resolve()
  }
  document.head.append(script)
})

export const getInstallationId = () => {
  if (typeof window === "undefined") return Promise.resolve()
  if (window.gwsInstallationId) return Promise.resolve().then(() => window.gwsInstallationId?.()).catch(() => undefined)
  return loadScript().then(() => window.gwsInstallationId?.()).catch(() => undefined)
}
